module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst protocolAction = model.nodeData || {}\nconst protocolActionAttributes = protocolAction.attributes || {}\nconst protocolActionFields = protocolActionAttributes.fields || {}\nconst protocolActionFieldsAttributes = protocolActionFields.attributes || {}\nconst protocolActionFieldsTemplateAtoms = protocolActionFields.templateAtoms || {}\nconst protocolActionFieldsEntitiesCategories = protocolActionFields.cms_entities_categories || {}\nconst langCode = storage.langCode || appConfig.language.default || 'de-at'\nconst nrOfFieldsAttributes = utils.collectionSize(protocolActionFieldsAttributes)\nconst nrOfFieldsTemplateAtoms = utils.collectionSize(protocolActionFieldsTemplateAtoms)\nconst nrOfFieldsEntitiesCategories = utils.collectionSize(protocolActionFieldsEntitiesCategories)\nconst nrOfChangedFields = nrOfFieldsAttributes + nrOfFieldsTemplateAtoms + nrOfFieldsEntitiesCategories\nconst showRows = {\nmethodTitle: true,\nentityID: true,\nuserTitle: true,\nloadingTS: 'ts',\nts: 'ts',\n}\n// resolve method\nconst methodOptions = (((model.namedFields ||{}).method || {})['category-picker-data'] || {}).options || []\nlet methodOption = {};\nfor(const o in methodOptions){\nconst option = methodOptions[o] || {}\nif(option.value === protocolActionAttributes.method){\nmethodOption = option\nbreak\n}\n}\nconst outerAdditionalStyles = []\nif(methodOption.color) outerAdditionalStyles.push(`background-color: ${methodOption.color};`)\nif((methodOption.config || {}).complementaryColor) outerAdditionalStyles.push(`color: ${methodOption.config.complementaryColor};`)\nconst name = ((methodOption.lang || {})[langCode] || {}).name\nconst description = ((methodOption.lang || {})[langCode] || {}).description\nprotocolActionAttributes.methodTitle = ''\nif(name){\nprotocolActionAttributes.methodTitle = name\nif(description){\nprotocolActionAttributes.methodTitle += ` (${description})`\n}\n} else {\nprotocolActionAttributes.methodTitle = protocolActionAttributes.method\n}\n// special messages\nconst message = {\nkey: '',\nvars: {}\n}\nif(\nprotocolActionAttributes.method === 'UPDATE' &&\nprotocolActionAttributes.entityType === 'route' &&\nprotocolActionAttributes.entityContext === 'route' &&\nnrOfChangedFields === 1 &&\nprotocolActionFieldsAttributes.templateID\n){\nmessage.key = `protocol.protocol.actionFormInfo.methodDescription.route.assignLayout`\nmessage.vars.templateID = protocolActionFieldsAttributes.templateID\n} else if (\nprotocolActionAttributes.method === 'UPDATE_MOVE'\n) {\nmessage.key = `protocol.protocol.actionFormInfo.methodDescription.UPDATE_MOVE`\n}\n%>\n<div>\n<div class=\"inner\">\n<%\nif(message.key){\n%><p><%- storage.__(message.key, message.vars) %></p><%\n}\n%>\n</div>\n<div class=\"outer\" style=\"<%- outerAdditionalStyles.join(' ') %>\">\n<table>\n<tbody>\n<%\nfor(attributeKey in showRows){\nconst showInFormat = showRows[attributeKey]\nlet value = protocolActionAttributes[attributeKey]\nif(showInFormat === 'ts'){\nif(value)   value = utils.moment(value).format('DD.MM.YYYY HH:mm:ss')\nelse        value = ''\n}\nif(showInFormat && value){\n%>\n<tr>\n<td class=\"head\"><%= storage.__(`protocol.protocol.actionFormInfo.rows.${attributeKey}`)%>:</td>\n<td class=\"body\" title=\"<%= value %>\"><%= value %></td>\n</tr>\n<%\n}\n}\n%>\n</tbody>\n</table>\n</div>\n</div>"
  , __filename = "components/templates/protocol/protocol/actionFormInfo.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const protocolAction = model.nodeData || {}
const protocolActionAttributes = protocolAction.attributes || {}
const protocolActionFields = protocolActionAttributes.fields || {}
const protocolActionFieldsAttributes = protocolActionFields.attributes || {}
const protocolActionFieldsTemplateAtoms = protocolActionFields.templateAtoms || {}
const protocolActionFieldsEntitiesCategories = protocolActionFields.cms_entities_categories || {}
const langCode = storage.langCode || appConfig.language.default || 'de-at'
const nrOfFieldsAttributes = utils.collectionSize(protocolActionFieldsAttributes)
const nrOfFieldsTemplateAtoms = utils.collectionSize(protocolActionFieldsTemplateAtoms)
const nrOfFieldsEntitiesCategories = utils.collectionSize(protocolActionFieldsEntitiesCategories)
const nrOfChangedFields = nrOfFieldsAttributes + nrOfFieldsTemplateAtoms + nrOfFieldsEntitiesCategories
const showRows = {
methodTitle: true,
entityID: true,
userTitle: true,
loadingTS: 'ts',
ts: 'ts',
}
// resolve method
const methodOptions = (((model.namedFields ||{}).method || {})['category-picker-data'] || {}).options || []
let methodOption = {};
for(const o in methodOptions){
const option = methodOptions[o] || {}
if(option.value === protocolActionAttributes.method){
methodOption = option
break
}
}
const outerAdditionalStyles = []
if(methodOption.color) outerAdditionalStyles.push(`background-color: ${methodOption.color};`)
if((methodOption.config || {}).complementaryColor) outerAdditionalStyles.push(`color: ${methodOption.config.complementaryColor};`)
const name = ((methodOption.lang || {})[langCode] || {}).name
const description = ((methodOption.lang || {})[langCode] || {}).description
protocolActionAttributes.methodTitle = ''
if(name){
protocolActionAttributes.methodTitle = name
if(description){
protocolActionAttributes.methodTitle += ` (${description})`
}
} else {
protocolActionAttributes.methodTitle = protocolActionAttributes.method
}
// special messages
const message = {
key: '',
vars: {}
}
if(
protocolActionAttributes.method === 'UPDATE' &&
protocolActionAttributes.entityType === 'route' &&
protocolActionAttributes.entityContext === 'route' &&
nrOfChangedFields === 1 &&
protocolActionFieldsAttributes.templateID
){
message.key = `protocol.protocol.actionFormInfo.methodDescription.route.assignLayout`
message.vars.templateID = protocolActionFieldsAttributes.templateID
} else if (
protocolActionAttributes.method === 'UPDATE_MOVE'
) {
message.key = `protocol.protocol.actionFormInfo.methodDescription.UPDATE_MOVE`
}

    ; __line = 63
    ; __append("\n<div>\n<div class=\"inner\">\n")
    ; __line = 66
    ; 
if(message.key){

    ; __line = 68
    ; __append("<p>")
    ; __append( storage.__(message.key, message.vars) )
    ; __append("</p>")
    ; 
}

    ; __line = 70
    ; __append("\n</div>\n<div class=\"outer\" style=\"")
    ; __line = 72
    ; __append( outerAdditionalStyles.join(' ') )
    ; __append("\">\n<table>\n<tbody>\n")
    ; __line = 75
    ; 
for(attributeKey in showRows){
const showInFormat = showRows[attributeKey]
let value = protocolActionAttributes[attributeKey]
if(showInFormat === 'ts'){
if(value)   value = utils.moment(value).format('DD.MM.YYYY HH:mm:ss')
else        value = ''
}
if(showInFormat && value){

    ; __line = 84
    ; __append("\n<tr>\n<td class=\"head\">")
    ; __line = 86
    ; __append(escapeFn( storage.__(`protocol.protocol.actionFormInfo.rows.${attributeKey}`)))
    ; __append(":</td>\n<td class=\"body\" title=\"")
    ; __line = 87
    ; __append(escapeFn( value ))
    ; __append("\">")
    ; __append(escapeFn( value ))
    ; __append("</td>\n</tr>\n")
    ; __line = 89
    ; 
}
}

    ; __line = 92
    ; __append("\n</tbody>\n</table>\n</div>\n</div>")
    ; __line = 96
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/protocol/protocol/actionFormInfo.ejs

}